<template>
  <div>
    <breadcrumbs :breadcrumbs="breadcrumbs"></breadcrumbs>
    <div class="innerWrapper" :class="{'mobile': mobile}">
      <div class="ui fluid icon input container" style="margin-bottom: 1rem">
        <input id="searchText" type="text" class="searchInput" v-model="searchText" :placeholder="text.commonSearchPlaceholder" autocomplete="off" autofocus="true" @input="searchInput()" @keydown.enter="searchEnter()">
        <i class="search icon"></i>
      </div>
      <div class="ui small active inline loader" v-show="searching"></div>
      <div v-show="!searching">
        <div class="ui error message noResults" v-show="searchText && !searchResults.length">{{ text.publicNoMemoSets }}</div>
        <div class="ui link divided items">
          <router-link class="item" v-for="memoSet in searchResults" :key="memoSet.memoSetId" :to="'public-memo-sets/' + memoSet.memoSetId + '/' + memoSet.slug">
            <div class="ui small image">
              <img :src="memoSet.coverImage">
            </div>
            <div class="content">
              <div class="ui grid">
                <div :class="{'eight wide column': !mobile, 'sixteen wide column': mobile}">
                  <div class="ui header noBottomMargin">
                    {{ memoSet.title }}
                  </div>
                  <div class="description" v-html="sanitize(memoSet.description)" v-show="memoSet.description"></div>
                </div>
                <div :class="{'eight wide column': !mobile, 'sixteen wide column': mobile}">
                  <div>
                    <h4 class="rightLabel"><b>{{ text.publicAuthor }}:</b></h4>
                    {{ memoSet.ownerName }}
                    <br>
                    <h4 class="rightLabel"><b>{{ text.commonRows }}:</b></h4>
                    {{ memoSet.rowCount }}
                    <br>
                    <h4 class="rightLabel"><b>{{ text.publicRating }}:</b></h4>
                    <div class="ui yellow star rating" style="position: relative; width: 7rem">
                      <div style="margin-top: -1rem; position: absolute">
                        <i class="star icon largeInactiveStar"></i>
                        <i class="star icon largeInactiveStar"></i>
                        <i class="star icon largeInactiveStar"></i>
                        <i class="star icon largeInactiveStar"></i>
                        <i class="star icon largeInactiveStar"></i>
                      </div>
                      <div style="margin-top: -1rem; position: absolute; overflow-x: hidden" :style="{width: memoSet.ratingWidth + 'rem'}">
                        <i class="star active icon"></i>
                        <i class="star active icon"></i>
                        <i class="star active icon"></i>
                        <i class="star active icon"></i>
                        <i class="star active icon"></i>
                      </div>
                    </div>
                    <span class="ratingsCount">({{ memoSet.ratingsCount }})</span>
                  </div>
                </div>
              </div>
            </div>
          </router-link>
        </div>
      </div>
      <br><br>
    </div>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/Breadcrumbs'
const firebase = window.firebase
const db = firebase.firestore()

function logError (errorCode, error) {
  console.log(errorCode)
  console.log(error)
}

export default {
  name: 'public-memo-sets',
  components: {
    Breadcrumbs
  },
  data () {
    return {
      lastSearchText: '',
      ratingsSummary: {},
      searching: false,
      searchResults: [],
      searchText: '',
      searchTimeout: null,
      topMemoSets: [],
      unsubscribeTop: null,
      userReady: false
    }
  },
  computed: {
    breadcrumbs: function () {
      return [
        {label: this.text.navHome, to: '/'},
        {label: this.text.navPublicMemoSets}
      ]
    }
  },
  created: function () {
    const self = this
    // TEMP - for debugging
    window.vm = this
    window.aoms = window.aoms || {}
    // Set memo set source - used by the MemoSet component
    window.aoms.memoSetSource = 'PublicMemoSets'
    this.checkUserReady()
    // Set previous search text and results if available
    if (window.aoms.memoSetSearchText) {
      this.searchText = window.aoms.memoSetSearchText
      this.searchResults = window.aoms.memoSetSearchResults
    } else {
      this.searching = true
    }
    // Listen to default memo sets
    this.unsubscribeTop = db.doc('topMemoSets/top')
      .onSnapshot(snapshot => {
        self.topMemoSets = snapshot.data().memoSets
        if (self.searching && !self.searchText) {
          self.searchResults = self.topMemoSets
          self.searching = false
        }
      }, error => { logError('PublicMemoSets_1', error) }
      )
    this.setPageTitle()
  },
  mounted: function () {
  },
  methods: {
    cancelSearchTimeout: function () {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout)
        this.searchTimeout = null
      }
    },
    checkUserReady: function () {
      // Redirect to Home page if the user data has loaded but the user isn't signed in
      if (this.user.uiLanguage && !this.user.folders) {
        this.$router.push('/')
      }
      if (this.user.folders) {
        this.userReady = true
      }
    },
    sanitize: function (html) {
      let sanitizedHtml
      if (!html) return ''
      sanitizedHtml = this.$sanitize(
        html,
        {
          allowedAttributes: {
            img: ['class', 'src']
          },
          allowedTags: ['b', 'br', 'i', 'img'],
          allowedSchemesByTag: {
            img: ['data', 'http', 'https']
          }
        }
      )
      return sanitizedHtml
    },
    search: function () {
      const self = this
      this.cancelSearchTimeout()
      if (this.searchText) {
        if (this.searchText.trim() !== this.lastSearchText) {
          this.lastSearchText = this.searchText.trim()
          db.collection('memoSetSearch')
            .add({
              searchText: this.searchText,
              timestamp: firebase.firestore.FieldValue.serverTimestamp(),
              userId: this.user.id
            })
            .then(docRef => {
              // Listen to the memoSetSearch document
              const detachListener = db.doc('memoSetSearch/' + docRef.id)
                .onSnapshot(snapshot => {
                  if (snapshot.data().done) {
                    detachListener()
                    if (!self.searchTimeout) {
                      self.searchResults = snapshot.data().memoSets
                      self.searching = false
                      // Save search and search results
                      window.aoms.memoSetSearchText = self.searchText
                      window.aoms.memoSetSearchResults = self.searchResults
                    }
                    // Delete the memoSetSearch document
                    db.doc('memoSetSearch/' + docRef.id)
                      .delete()
                      .catch(error => { logError('PublicMemoSets_2', error) })
                  }
                }, error => { logError('PublicMemoSets_3', error) })
            })
            .catch(error => { logError('PublicMemoSets_4', error) })
        } else {
          // No real change to search text - show previous results
          this.searching = false
        }
      } else {
        this.searchResults = this.topMemoSets
        this.searching = false
        this.lastSearchText = ''
        window.aoms.memoSetSearchText = ''
      }
    },
    searchEnter: function () {
      // If there's a search timeout, just search now
      this.cancelSearchTimeout()
      this.search()
    },
    searchInput: function () {
      // Update this.searchText if not updated - needed on mobile, where value doesn't change with each keystroke
      if (this.searchText !== document.getElementById('searchText').value) {
        this.searchText = document.getElementById('searchText').value
      }
      this.cancelSearchTimeout()
      this.searchTimeout = setTimeout(this.search, 600)
      this.searching = true
    },
    setPageTitle: function () {
      if (this.text && this.text.navPublicMemoSets) {
        document.title = this.text.navPublicMemoSets + ' - MemQ'
      }
    }
  },
  props: ['mobile', 'text', 'touch', 'user', 'window'],
  watch: {
    text: function (newText) {
      this.setPageTitle()
    },
    user: function (newUser) {
      this.checkUserReady()
    }
  }
}
</script>

<style scoped>
  /* Add space below heading */
  h2 {
    margin-bottom: 1.5rem;
  }
  /* Move loading indictor down a little */
  .loader {
     margin-top: 0.6rem !important;
  }
  /* Indent loading indicator on mobile */
  .innerWrapper.mobile .loader {
    margin-left: 1rem;
  }
  /* Add margins to no search results message on mobile */
  .innerWrapper.mobile .noResults {
    margin-left: 1rem;
    margin-right: 1rem;
  }
  /* Copy seach box style from Semantic .ui.search .prompt */
  .searchInput {
    border-radius: 500rem !important;
  }
  .rightLabel {
    display: inline-block;
    margin-top: 0;
    width: 9rem;
  }
  .rightLabel:first-child {
    margin-top: 0;
  }
  .ratingsCount {
    color: gray;
    margin-left: 1rem;
  }
  .largeInactiveStar {
    text-shadow: 0 -1px 0 gainsboro,-1px 0 0 silver,0 1px 0 silver,1px 0 0 silver !important;
  }
  .item:hover {
    background-color: #e6e9ef;
  }
  .item {
    padding-left: 1em !important;
    padding-right: 1em !important;
  }
  .item > .image {
    margin-left: 0 !important;
    width: 80px !important;
  }
  /* Add left and right margin on mobile */
  .innerWrapper.mobile .ui.items {
    margin-left: 1rem;
    margin-right: 1rem;
  }
  /* Reduce maximum height of images on mobile - matches Semantic's rule to override it */
  @media only screen and (max-width: 767.98px) {
    .ui.items:not(.unstackable)>.item>.image, .ui.items:not(.unstackable)>.item>.image>img {
      max-height: 80px !important;
    }
  }
  /* Give top padding to first memo set */
  .ui.divided.items>.item:first-child {
    padding-top: 1em !important;
  }
  /* Give bottom padding to last memo set */
    .ui.divided.items>.item:last-child {
    padding-bottom: 1em !important;
  }
  /* Prevent memo set title changing color on hover */
  div.ui.header {
    color: rgba(0,0,0,.87) !important;
  }
  .noBottomMargin {
    margin-bottom: 0 !important;
  }
  .description {
    margin-top: 1rem;
  }
  .ui.link.divided.items {
    background-color: white;
    border: 1px solid rgba(34,36,38,.15);
    border-radius: 0.28571429rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/PublicMemoSets.vue